import { BaseLazyObserver } from './baseLazyObserver';

/**
 * 图片懒加载观察者类
 */
export default class ImgsLazyObserver extends BaseLazyObserver {
    static observerCaches: Map<string, ImgsLazyObserver> = new Map();

    /**
     * 创建一个ImgsLazyObserver实例
     * @param options IntersectionObserver的配置项
     * @returns ImgsLazyObserver实例
     */
    static getObserver(options: IntersectionObserverInit) {
        const observerKey = JSON.stringify(options);
        let observer = ImgsLazyObserver.observerCaches.get(observerKey);
        if (!observer) {
            observer = new ImgsLazyObserver(options);
            ImgsLazyObserver.observerCaches.set(observerKey, observer);
        }
        return observer;
    }

    /**
     * 判断目标元素是否为图片元素
     * @param target 目标元素
     * @returns 是否为图片元素
     */
    static isImgEle(target: Element): target is HTMLImageElement {
        return target.tagName.toUpperCase() === 'IMG';
    }

    /**
     * 设置图片URL
     * @param element 目标元素
     * @param src 图片URL
     */
    static setImgUrl(element: HTMLElement, src: string) {
        try {
            if (ImgsLazyObserver.isImgEle(element)) {
                element.src = src;
            } else {
                element.style.backgroundImage = `url(${src})`;
            }
        } catch (e) {
            console.error(e);
        }
    }

    constructor(options: IntersectionObserverInit) {
        super(options);
        this.initObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.setImageSource(entry.target as HTMLElement);
                }
            });
        });
    }

    private setImageSource(element: HTMLElement) {
        this.unobserve(element);
        const src = element.getAttribute('data-src') || '';
        src && ImgsLazyObserver.setImgUrl(element, src);
        element.removeAttribute('data-src');
    }

    public observe(node: HTMLElement) {
        const isSupportIntersection = super.observe(node);
        if (!isSupportIntersection) {
            this.setImageSource(node);
        }
        return true;
    }
}
